import { definitions } from "../../common-fetch/generated/partners-model-api";
import { atom } from "../../common/miscellaneous/atom";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

type NoSampleQuestions = Omit<
  definitions["PartnerSettingsDto"],
  "sampleQuestions"
>;
type SampleQuestion = NonNullable<
  definitions["PartnerSettingsDto"]["sampleQuestions"]
>["0"];
type RowId = { readonly rowId: string };
export type SettingsWithRowIds = NoSampleQuestions & {
  readonly sampleQuestions?: readonly (SampleQuestion & RowId)[];
};

export type SettingsState = SettingsWithRowIds | "initializing";

export const settingsAtom = atom<SettingsState>({
  key: RecoilKeys.Settings,
  default: "initializing",
});
